import React from "react";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import TokoTidakAktif from "../../components/TokoTidakAktif/TokoTidakAktif";
import { useAuthStore } from "../../stores/authStore";
import scrollToHash from "../../utils/scrollToHash";
import Spinner from "../../components/Spinner/Spinner";
import moment from "moment";
import "moment/locale/id";
import useTransaksiErrorToast from "./hooks/useTransaksiErrorToast";
import useTransaksiPageData from "./hooks/useTransaksiPageData";
import useTransaksiPopup from "./hooks/useTransaksiPopup";
import useTransaksiRedirect from "./hooks/useTransaksiRedirect";
import useTransaksiViewState from "./hooks/useTransaksiViewState";
import TransaksiCartFab from "./components/TransaksiCartFab";
import TransaksiLayout from "./components/TransaksiLayout";
import TransaksiModals from "./components/TransaksiModals";

moment.locales();
moment.locale("id");

const Transaksi = () => {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const theme = useTheme();
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("lg"));

    const {
        statusTime,
        statusUkm,
        statusUser,
        ukm,
        ukmData,
        ukmId,
        user,
        hasNoAccess,
        isTokoTidakAktif,
    } = useTransaksiPageData();
    const {
        isCardView,
        isModalMutasiOpen,
        handleCardView,
        handleCloseModalMutasi,
        handleListView,
        handleOpenModalMutasi,
    } = useTransaksiViewState();
    const handleIsError = useTransaksiErrorToast();
    const { isWaitingForRedirectSync } = useTransaksiRedirect({
        ukm,
        ukmId,
        userId: user?.userId,
    });
    const { isOpenPopup, closePopup } = useTransaksiPopup({
        isAuthenticated,
        isTrial: ukmData?.isTrial,
        trialFlag10: ukmData?.trialFlag10,
    });

    React.useEffect(() => {
        scrollToHash();
    }, []);

    if (
        statusUser === "loading" ||
        statusUkm === "loading" ||
        statusTime === "loading" ||
        isWaitingForRedirectSync
    ) {
        return (
            <Box
                position="relative"
                height={isLaptopScreen ? "100vh" : "calc(100vh - 56px)"}
            >
                <Spinner />
            </Box>
        );
    }

    if (hasNoAccess) {
        return <TokoTidakAktif label="Anda tidak memiliki akses halaman ini" />;
    }

    if (ukmData && isTokoTidakAktif) {
        return <TokoTidakAktif namaToko={ukmData.namaToko} />;
    }

    return (
        <Box bgcolor="#ffffff">
            <TransaksiLayout
                isCardView={isCardView}
                onCardView={handleCardView}
                onListView={handleListView}
                onError={handleIsError}
                onOpenMutasi={handleOpenModalMutasi}
            />
            <TransaksiCartFab />
            <TransaksiModals
                isModalMutasiOpen={isModalMutasiOpen}
                isOpenPopup={isOpenPopup}
                namaToko={ukmData?.namaToko}
                onCloseMutasi={handleCloseModalMutasi}
                onClosePopup={closePopup}
                trialFlag10={ukmData?.trialFlag10}
                trialTempo={ukmData?.trialTempo}
                ukmId={ukmData?.id}
            />
        </Box>
    );
};

export default Transaksi;
